import { createFileRoute } from '@tanstack/react-router'
import { VisitorDetailsEventsPage } from 'features/visitorDetails'
import { z } from 'zod/v4'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/events')({
  component: VisitorDetailsEventsPage,
  validateSearch: z.object({
    /** Comma-separated event IDs to narrow the list to (e.g. drill-down from a location row) */
    eventIds: z.string().optional(),
    /** Event ID to scroll to and highlight */
    highlightRequestId: z.string().optional(),
    /** Comma-separated smart signal ids to filter by (e.g. deep link from the Smart Signals tab) */
    signals: z.string().optional(),
  }),
})
